<template>
  <VoiceRightFormTab />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
